<nb-alert class='{{class}}' status='{{type}}'>
  <div *ngIf='showIcon' class='info-icon'>
    <nb-icon icon='info-outline' nbPrefix pack='eva'></nb-icon>
  </div>
  <div class='info-text'>
    <h5>{{title}}</h5>
    {{infoText}}
  </div>
</nb-alert>
